
import { useTranslate } from 'src/locales';
import { DealStatus } from 'src/services/deal-flow/deal-flow.types';

import Label, { LabelProps } from 'src/components/label';

type Props = {
  status: DealStatus;
} & LabelProps;

export default function DealStatusLabel({ status, sx, ref, ...other }: Props) {

  const { t } = useTranslate();

  const getLabelColor = (jobStatus: DealStatus) => {
    switch (status) {
      case DealStatus.ACTIVE:
        return 'info';
      case DealStatus.WON:
        return 'success';
      case DealStatus.LOST:
        return 'error';
      default:
        return 'default';
    }
  };


  return (
    <Label variant="soft" sx={{ ...sx }} {...other} color={getLabelColor(status)}>
      {t(`enums.deal_status.${status}`)}
    </Label>
  );
}
